import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Box, Grid, CardMedia, CardContent, Card, Typography } from '@mui/material';
import useImageUriGenerator from './ImgUriGenerator';
 


const GuideCard = ({ guide, imageDataURI }) => {
    const truncationLength = 150;
    const truncatedDescription = guide.description.slice(0, truncationLength) + (guide.description.length > truncationLength ? '...' : '');
  
    return (
        <Card className="guideCard">
            
          
        <CardMedia className="guideCardMedia" 
        component={"img"}
        src={imageDataURI}
       /* style={{ padding: '25px', width: '410px', height: '231px' }} /> */

       style={{ width: '100%', height: '50%' }} />
    
        
       <CardContent className="guideCardContent" style={{ width: '100%', height: '200px' }}>
          <Typography className="guideCardContentTitle" gutterBottom variant="h3" component="h3" sx={{ fontSize: '24px', fontFamily: 'Inter', fontWeight: 700, lineHeight: '36px' }}>
            {guide.title}
          </Typography>
          <Typography className="guideCardContentParagraph" variant="body1" sx={{ fontSize: '18px', fontFamily: 'DM Sans', fontWeight: 400, lineHeight: '24px', textAlign: 'justify',paddingRight:'40px' }}>
            {truncatedDescription}{" "}
            <Link to={`/support/article/${guide.id}/${encodeURIComponent(guide.title)}`} className="guide-link">
          
               read more
        
          </Link>
          </Typography>
         
        </CardContent>
      </Card>
    );
  };
  
  export default GuideCard;
  